import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import moment from "moment";
import cx from "classnames";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { post } from 'axios';
import { _O } from "../../modules/utils";

// Env
import Swiper from "../../modules/env/swiper-bundle.min.js";

// UI
import { Container, openLayerFn, closeLayerFn, DateLayer } from "../Layout";

// 확인 다이얼로그 [[
export const AlertDialogLayer = memo((props) => {
    useEffect(() => {
        $(".dialog-layer .tbns-area a").click(function(){
            closeLayerFn($(".dialog-layer"));
        });
    })

    return (
        <div className="blacklayer-container dialog-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">

                <div>
                    <div className="blgrn-box vertical priv">
                        <div className="blgr-title">{props.title}</div>

                        <div className="save-question-box">
                            <span className="utt">{props.msg}</span>
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round wht">확인</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
});
// 확인 다이얼로그 ]]